import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const COP = (n) =>
  new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 })
    .format(Number(n) || 0);
const num = (v) => parseFloat(v) || 0;

const CUENTAS = {
  'Nuestro':       'Bancolombia Nuestro',
  'Buenavista':    'Bancolombia Buenavista',
  'Parque Alegra': 'Bancolombia Empresarial',
  'Alamedas':      'Bancolombia Empresarial',
};

// ─────────────────────────────────────────
// MODAL REGISTRAR DESTINO
// ─────────────────────────────────────────
function ModalDestino({ fila, onClose, onGuardado }) {
  const [destino, setDestino] = useState('consignacion');
  const [retiradoPor, setRetiradoPor] = useState('');
  const [notas, setNotas] = useState('');
  const [foto, setFoto] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [guardando, setGuardando] = useState(false);

  const cuentaDestino = CUENTAS[fila.bodega] || 'Bancolombia Empresarial';

  const handleFoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFoto(file);
    const reader = new FileReader();
    reader.onload = (ev) => setFotoPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleGuardar = async () => {
    if (destino === 'consignacion' && !foto) {
      toast.error('Toma una foto de la consignación'); return;
    }
    if (destino === 'retiro_gerencia' && !retiradoPor) {
      toast.error('Ingresa el nombre de quien retiró'); return;
    }
    setGuardando(true);
    try {
      const r = await API.post('/sobres', {
        cierre_caja_id: fila.cierre_id,
        bodega_id: fila.bodega_id,
        fecha: fila.fecha,
        destino,
        cuenta_destino: destino === 'consignacion' ? cuentaDestino : null,
        retirado_por: destino === 'retiro_gerencia' ? retiradoPor : null,
        notas,
      });
      if (foto && r.data?.id) {
        const formData = new FormData();
        formData.append('foto', foto);
        await API.post(`/sobres/${r.data.id}/foto`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      toast.success('Sobre registrado correctamente');
      onGuardado();
      onClose();
    } catch { toast.error('Error al registrar sobre'); }
    finally { setGuardando(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 440, boxShadow: '0 24px 64px rgba(0,0,0,0.3)', overflow: 'hidden' }}>
        {/* Header */}
        <div style={{ background: '#1a1a2e', color: 'white', padding: '18px 24px' }}>
          <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 2 }}>💵 Registrar destino del sobre</div>
          <div style={{ fontSize: 18, fontWeight: 800 }}>🏪 {fila.bodega}</div>
          <div style={{ fontSize: 13, opacity: 0.8, marginTop: 4 }}>
            {format(new Date(fila.fecha.slice(0,10)+'T12:00'), "d 'de' MMMM yyyy", { locale: es })} — {COP(fila.total_efectivo)}
          </div>
        </div>

        <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* Tipo de destino */}
          <div>
            <label style={st.label}>¿Qué pasó con el efectivo?</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 6 }}>
              <button
                onClick={() => setDestino('consignacion')}
                style={{ ...st.opcion, border: `2px solid ${destino === 'consignacion' ? '#10B981' : '#E5E7EB'}`, background: destino === 'consignacion' ? '#F0FDF4' : 'white' }}
              >
                <span style={{ fontSize: 20 }}>🏦</span>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>Consignación bancaria</div>
                  <div style={{ fontSize: 12, color: '#6B7280' }}>→ {cuentaDestino}</div>
                </div>
              </button>
              <button
                onClick={() => setDestino('retiro_gerencia')}
                style={{ ...st.opcion, border: `2px solid ${destino === 'retiro_gerencia' ? '#6366F1' : '#E5E7EB'}`, background: destino === 'retiro_gerencia' ? '#EEF2FF' : 'white' }}
              >
                <span style={{ fontSize: 20 }}>🤝</span>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>Retiro por Gerencia</div>
                  <div style={{ fontSize: 12, color: '#6B7280' }}>Gerencia retiró el efectivo</div>
                </div>
              </button>
            </div>
          </div>

          {/* Campos según tipo */}
          {destino === 'consignacion' ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div>
                <label style={st.label}>Foto de la consignación *</label>
                {fotoPreview ? (
                  <div style={{ position: 'relative' }}>
                    <img src={fotoPreview} alt="Consignación" style={{ width: '100%', borderRadius: 10, maxHeight: 200, objectFit: 'cover', border: '2px solid #10B981' }} />
                    <button
                      onClick={() => { setFoto(null); setFotoPreview(null); }}
                      style={{ position: 'absolute', top: 8, right: 8, background: '#EF4444', color: 'white', border: 'none', borderRadius: '50%', width: 28, height: 28, cursor: 'pointer', fontSize: 14, fontWeight: 700 }}
                    >✕</button>
                  </div>
                ) : (
                  <label style={{ display: 'block', cursor: 'pointer' }}>
                    <div style={{ border: '2px dashed #D1D5DB', borderRadius: 10, padding: '20px', textAlign: 'center', background: '#F9FAFB' }}>
                      <div style={{ fontSize: 32, marginBottom: 6 }}>📸</div>
                      <div style={{ fontWeight: 700, color: '#374151', fontSize: 14 }}>Tomar foto</div>
                      <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 2 }}>Usa la cámara de tu celular</div>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      capture="environment"
                      onChange={handleFoto}
                      style={{ display: 'none' }}
                    />
                  </label>
                )}
              </div>
            </div>
          ) : (
            <div>
              <label style={st.label}>¿Quién retiró? *</label>
              <input
                value={retiradoPor}
                onChange={e => setRetiradoPor(e.target.value)}
                placeholder="Nombre de quien retiró"
                style={st.input}
              />
            </div>
          )}

          <div>
            <label style={st.label}>Notas (opcional)</label>
            <textarea
              value={notas}
              onChange={e => setNotas(e.target.value)}
              rows={2}
              placeholder="Observaciones adicionales..."
              style={{ ...st.input, resize: 'none', fontFamily: 'inherit' }}
            />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, padding: '16px 24px', borderTop: '1px solid #F3F4F6', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={st.btnSec}>Cancelar</button>
          <button onClick={handleGuardar} disabled={guardando} style={{ ...st.btnPri, background: destino === 'consignacion' ? 'linear-gradient(135deg,#059669,#047857)' : 'linear-gradient(135deg,#4F46E5,#4338CA)' }}>
            {guardando ? '⏳ Guardando...' : '✓ Registrar'}
          </button>
        </div>
      </div>
    </div>
  );
}

const st = {
  label: { fontSize: 11, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 4 },
  input: { width: '100%', padding: '10px 14px', border: '2px solid #E5E7EB', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  opcion: { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderRadius: 12, cursor: 'pointer', transition: 'all 0.15s', textAlign: 'left', width: '100%' },
  btnSec: { padding: '10px 20px', border: '2px solid #E5E7EB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#374151' },
  btnPri: { padding: '10px 24px', border: 'none', borderRadius: 8, color: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 700 },
};


// ─────────────────────────────────────────
// MODAL CONSIGNACIÓN MÚLTIPLE
// ─────────────────────────────────────────
function ModalConsignacionMultiple({ filasPendientes, onClose, onGuardado }) {
  const [seleccionadas, setSeleccionadas] = useState({});
  const [foto, setFoto] = useState(null);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [destino, setDestino] = useState('consignacion');
  const [retiradoPor, setRetiradoPor] = useState('');
  const [notas, setNotas] = useState('');
  const [guardando, setGuardando] = useState(false);

  const seleccionadasList = filasPendientes.filter(f => seleccionadas[f.cierre_id]);
  const totalSeleccionado = seleccionadasList.reduce((a, f) => a + (parseFloat(f.total_efectivo) || 0), 0);
  const COP = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Number(n) || 0);

  const handleFoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFoto(file);
    const reader = new FileReader();
    reader.onload = (ev) => setFotoPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleGuardar = async () => {
    if (seleccionadasList.length === 0) { toast.error('Selecciona al menos un día'); return; }
    if (destino === 'consignacion' && !foto) { toast.error('Adjunta la foto de la consignación'); return; }
    if (destino === 'retiro_gerencia' && !retiradoPor) { toast.error('Ingresa quién retiró'); return; }
    setGuardando(true);
    try {
      // Registrar cada sobre individualmente pero con la misma foto/notas
      const sobresCreados = [];
      for (const fila of seleccionadasList) {
        const cuentaDestino = CUENTAS[fila.bodega] || 'Bancolombia Empresarial';
        const r = await API.post('/sobres', {
          cierre_caja_id: fila.cierre_id,
          bodega_id: fila.bodega_id,
          fecha: fila.fecha,
          destino,
          cuenta_destino: destino === 'consignacion' ? cuentaDestino : null,
          retirado_por: destino === 'retiro_gerencia' ? retiradoPor : null,
          notas: notas || `Consignación múltiple — ${seleccionadasList.length} días`,
        });
        if (r.data?.id) sobresCreados.push(r.data.id);
      }
      // Subir la foto a todos los sobres creados
      if (foto && sobresCreados.length) {
        for (const id of sobresCreados) {
          const formData = new FormData();
          formData.append('foto', foto);
          await API.post(`/sobres/${id}/foto`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
      }
      toast.success(`✅ ${seleccionadasList.length} sobres registrados correctamente`);
      onGuardado();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error al registrar');
    } finally { setGuardando(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 520, maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 64px rgba(0,0,0,0.3)' }}>
        {/* Header */}
        <div style={{ background: '#1a1a2e', color: 'white', padding: '18px 24px', flexShrink: 0 }}>
          <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 2 }}>🏦 Consignación múltiple</div>
          <div style={{ fontSize: 18, fontWeight: 800 }}>Registrar varios días a la vez</div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* Selector de días */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', marginBottom: 8 }}>
              Días a incluir ({seleccionadasList.length} seleccionados)
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 200, overflowY: 'auto' }}>
              {filasPendientes.map(f => (
                <label key={f.cierre_id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: seleccionadas[f.cierre_id] ? '#EFF6FF' : '#F9FAFB', borderRadius: 8, cursor: 'pointer', border: `1px solid ${seleccionadas[f.cierre_id] ? '#BFDBFE' : '#E5E7EB'}` }}>
                  <input type="checkbox" checked={!!seleccionadas[f.cierre_id]}
                    onChange={e => setSeleccionadas(s => ({ ...s, [f.cierre_id]: e.target.checked }))}
                    style={{ width: 16, height: 16 }} />
                  <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: '#374151' }}>
                    {format(new Date(f.fecha.slice(0,10)+'T12:00'), "EEEE d 'de' MMMM", { locale: es })}
                  </span>
                  <span style={{ fontWeight: 800, color: '#10B981', fontSize: 13, fontFamily: 'monospace' }}>
                    {COP(f.total_efectivo)}
                  </span>
                </label>
              ))}
            </div>
            {seleccionadasList.length > 0 && (
              <div style={{ marginTop: 8, padding: '8px 12px', background: '#F0FDF4', borderRadius: 8, display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <span style={{ fontWeight: 600, color: '#065F46' }}>Total a consignar:</span>
                <span style={{ fontWeight: 800, color: '#059669', fontFamily: 'monospace' }}>{COP(totalSeleccionado)}</span>
              </div>
            )}
          </div>

          {/* Tipo destino */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', marginBottom: 8 }}>Tipo</div>
            <div style={{ display: 'flex', gap: 8 }}>
              {[{ v: 'consignacion', l: '🏦 Consignación' }, { v: 'retiro_gerencia', l: '🤝 Retiro Gerencia' }].map(op => (
                <button key={op.v} onClick={() => setDestino(op.v)} style={{
                  flex: 1, padding: '10px', border: `2px solid ${destino === op.v ? '#1a1a2e' : '#E5E7EB'}`,
                  borderRadius: 10, background: destino === op.v ? '#1a1a2e' : 'white',
                  color: destino === op.v ? 'white' : '#374151', cursor: 'pointer', fontWeight: 700, fontSize: 13,
                }}>{op.l}</button>
              ))}
            </div>
          </div>

          {/* Foto consignación */}
          {destino === 'consignacion' && (
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', marginBottom: 8 }}>Foto comprobante *</div>
              {fotoPreview ? (
                <div style={{ position: 'relative' }}>
                  <img src={fotoPreview} alt="Comprobante" style={{ width: '100%', maxHeight: 180, objectFit: 'cover', borderRadius: 10 }} />
                  <button onClick={() => { setFoto(null); setFotoPreview(null); }}
                    style={{ position: 'absolute', top: 6, right: 6, background: '#EF4444', color: 'white', border: 'none', borderRadius: '50%', width: 28, height: 28, cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>✕</button>
                </div>
              ) : (
                <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '24px', background: '#F9FAFB', border: '2px dashed #E5E7EB', borderRadius: 10, cursor: 'pointer', color: '#6B7280', fontSize: 14, fontWeight: 600 }}>
                  📷 Tomar o adjuntar foto
                  <input type="file" accept="image/*" capture="environment" onChange={handleFoto} style={{ display: 'none' }} />
                </label>
              )}
            </div>
          )}

          {/* Quién retiró */}
          {destino === 'retiro_gerencia' && (
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', marginBottom: 8 }}>Retirado por *</div>
              <input value={retiradoPor} onChange={e => setRetiradoPor(e.target.value)}
                placeholder="Nombre de quien retiró"
                style={{ width: '100%', padding: '9px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
            </div>
          )}

          {/* Notas */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', marginBottom: 8 }}>Notas (opcional)</div>
            <textarea value={notas} onChange={e => setNotas(e.target.value)}
              placeholder="Ej: Consignación del 3 al 6 de marzo..."
              rows={2} style={{ width: '100%', padding: '9px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }} />
          </div>
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', gap: 10, padding: '16px 24px', borderTop: '1px solid #F3F4F6', flexShrink: 0 }}>
          <button onClick={onClose} style={{ flex: 1, padding: '10px', border: '2px solid #E5E7EB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#374151' }}>
            Cancelar
          </button>
          <button onClick={handleGuardar} disabled={guardando || seleccionadasList.length === 0}
            style={{ flex: 2, padding: '10px', border: 'none', borderRadius: 8, background: seleccionadasList.length === 0 ? '#E5E7EB' : 'linear-gradient(135deg,#1a1a2e,#16213e)', color: seleccionadasList.length === 0 ? '#9CA3AF' : 'white', cursor: seleccionadasList.length === 0 ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 700 }}>
            {guardando ? '⏳ Registrando...' : `✅ Registrar ${seleccionadasList.length} día${seleccionadasList.length !== 1 ? 's' : ''} — ${COP(totalSeleccionado)}`}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────
// MÓDULO PRINCIPAL
// ─────────────────────────────────────────
export default function Sobres() {
  const { usuario, puedeVer } = useAuth();
  const esGerencia = puedeVer('gerencia');
  const esAdmin = puedeVer('administracion', 'gerencia');
  const esPDV = puedeVer('punto_venta');

  const hoy = new Date();
  const [mes, setMes] = useState(hoy.getMonth() + 1);
  const [anio, setAnio] = useState(hoy.getFullYear());
  const [filas, setFilas] = useState([]);
  const [listaBodegas, setListaBodegas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modalFila, setModalFila] = useState(null);
  const [modalMultiple, setModalMultiple] = useState(false);
  const [fotoVisor, setFotoVisor] = useState(null);
  const [filtroBodega, setFiltroBodega] = useState('');

  useEffect(() => {
    if (esAdmin) {
      API.get('/bodegas').then(r => setListaBodegas(r.data.filter(b => b.tipo === 'punto_venta'))).catch(() => {});
    }
  }, []);

  const cargar = () => {
    setCargando(true);
    const params = { mes, anio };
    if (filtroBodega) params.bodega_id = filtroBodega;

    API.get('/sobres', { params })
      .then(r => setFilas(r.data))
      .catch(() => toast.error('Error cargando sobres'))
      .finally(() => setCargando(false));
  };

  useEffect(() => { cargar(); }, [mes, anio, filtroBodega]);

  // Agrupar por bodega para la vista
  const bodegas = [...new Set(filas.map(f => f.bodega))];
  const pendientes = filas.filter(f => !f.sobre_id && f.cierre_id);
  const totalPendiente = pendientes.reduce((a, f) => a + num(f.total_efectivo), 0);

  const meses = [
    'Enero','Febrero','Marzo','Abril','Mayo','Junio',
    'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
  ];

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", maxWidth: 960, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>💵 Sobres</h1>
        <p style={{ margin: '4px 0 0', color: '#6B7280', fontSize: 14 }}>Trazabilidad del efectivo por punto de venta</p>
      </div>

      {/* Alertas de pendientes */}
      {pendientes.length > 0 && (
        <div style={{ background: '#FEF3C7', border: '1px solid #FCD34D', borderRadius: 12, padding: '14px 18px', marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <div>
            <div style={{ fontWeight: 800, color: '#92400E', fontSize: 15 }}>⚠️ {pendientes.length} sobre{pendientes.length > 1 ? 's' : ''} sin registrar destino</div>
            {esGerencia && <div style={{ fontSize: 13, color: '#B45309', marginTop: 2 }}>Total acumulado: <strong>{COP(totalPendiente)}</strong></div>}
          </div>
        </div>
      )}

      {/* Filtros */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Mes</label>
          <select value={mes} onChange={e => setMes(Number(e.target.value))} style={st.input}>
            {meses.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Año</label>
          <select value={anio} onChange={e => setAnio(Number(e.target.value))} style={st.input}>
            {[2025, 2026, 2027].map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        {esAdmin && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Bodega</label>
            <select value={filtroBodega} onChange={e => setFiltroBodega(e.target.value)} style={st.input}>
              <option value="">Todas</option>
              {listaBodegas.map(b => <option key={b.id} value={b.id}>{b.nombre}</option>)}
            </select>
          </div>
        )}

      </div>

      {/* Botón consignación múltiple */}
      {(esPDV || esAdmin) && filas.filter(f => !f.sobre_id && f.cierre_id).length > 1 && (
        <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: 12, padding: '14px 18px', marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <div>
            <div style={{ fontWeight: 700, color: '#1E40AF', fontSize: 14 }}>💡 Consignación múltiple</div>
            <div style={{ fontSize: 12, color: '#3B82F6', marginTop: 2 }}>
              Tienes {filas.filter(f => !f.sobre_id && f.cierre_id).length} días pendientes — puedes registrarlos con una sola consignación
            </div>
          </div>
          <button
            onClick={() => setModalMultiple(true)}
            style={{ padding: '8px 18px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#1E40AF,#1a1a2e)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}
          >
            🏦 Registrar consignación múltiple
          </button>
        </div>
      )}

      {/* Tabla por bodega */}
      {cargando ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>Cargando sobres...</div>
      ) : filas.length === 0 ? (
        <div style={{ background: 'white', borderRadius: 14, padding: 40, textAlign: 'center', color: '#9CA3AF', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>📭</div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>Sin cierres registrados en {meses[mes - 1]} {anio}</div>
        </div>
      ) : (
        bodegas.map(bodega => {
          const filasBody = filas.filter(f => f.bodega === bodega);
          const pendBody = filasBody.filter(f => !f.sobre_id && f.cierre_id);
          const cuentaDestino = CUENTAS[bodega] || '—';

          return (
            <div key={bodega} style={{ background: 'white', borderRadius: 14, marginBottom: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
              {/* Header bodega */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', background: '#1a1a2e', color: 'white', flexWrap: 'wrap', gap: 8 }}>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 800 }}>🏪 {bodega}</div>
                  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>Cuenta: {cuentaDestino}</div>
                </div>
                <div style={{ display: 'flex', gap: 16, fontSize: 13 }}>
                  {pendBody.length > 0 && (
                    <div style={{ background: '#FCD34D', color: '#92400E', padding: '4px 12px', borderRadius: 20, fontWeight: 700, fontSize: 12 }}>
                      ⚠️ {pendBody.length} pendiente{pendBody.length > 1 ? 's' : ''}
                    </div>
                  )}
                  <div style={{ opacity: 0.8 }}>{filasBody.length} días</div>
                  {esGerencia && (
                    <div style={{ fontWeight: 700 }}>
                      Pendiente: {COP(pendBody.reduce((a, f) => a + num(f.total_efectivo), 0))}
                    </div>
                  )}
                </div>
              </div>

              {/* Tabla de días */}
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: '#F9FAFB' }}>
                      <th style={th}>Fecha</th>
                      <th style={th}>Efectivo del sobre</th>
                      <th style={th}>Destino</th>
                      <th style={th}>Quién retiró</th>
                      <th style={th}>Registrado</th>
                      <th style={th}>Foto</th>
                      <th style={th}>Estado</th>
                      <th style={th}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filasBody.map((fila, i) => {
                      const registrado = !!fila.sobre_id;
                      const sinCierre = !fila.cierre_id;
                      const fotoUrl = fila.foto_consignacion
                        ? `https://erp.gelatus.co/uploads/consignaciones/${fila.foto_consignacion}`
                        : null;
                      return (
                        <tr key={i} style={{ borderTop: '1px solid #F3F4F6', background: !registrado && !sinCierre ? '#FFFBEB' : i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                          <td style={td}>
                            <span style={{ fontWeight: 700 }}>
                              {format(new Date(fila.fecha.slice(0,10)+'T12:00'), "d MMM", { locale: es })}
                            </span>
                            <span style={{ color: '#9CA3AF', fontSize: 11, marginLeft: 4 }}>
                              {format(new Date(fila.fecha.slice(0,10)+'T12:00'), 'yyyy')}
                            </span>
                          </td>
                          <td style={{ ...td, fontFamily: 'monospace', fontWeight: 800, color: '#10B981' }}>
                            {fila.cierre_id ? COP(fila.total_efectivo) : <span style={{ color: '#D1D5DB' }}>Sin cierre</span>}
                          </td>
                          <td style={td}>
                            {registrado ? (
                              fila.destino === 'consignacion'
                                ? <span style={{ color: '#3B82F6', fontWeight: 600 }}>🏦 Consignación</span>
                                : <span style={{ color: '#6366F1', fontWeight: 600 }}>🤝 Retiro Gerencia</span>
                            ) : '—'}
                          </td>
                          <td style={td}>
                            {registrado && fila.retirado_por ? (
                              <span style={{ fontSize: 12, color: '#374151' }}>{fila.retirado_por}</span>
                            ) : '—'}
                          </td>
                          <td style={td}>
                            {fila.registrado_at ? (
                              <span style={{ fontSize: 11, color: '#9CA3AF' }}>
                                {format(new Date(fila.registrado_at), 'd/M HH:mm')}
                                <br />{fila.registrado_por}
                              </span>
                            ) : '—'}
                          </td>
                          <td style={td}>
                            {fotoUrl ? (
                              <button
                                onClick={() => setFotoVisor(fotoUrl)}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, padding: 0 }}
                                title="Ver foto"
                              >📷</button>
                            ) : esAdmin && registrado && fila.destino === 'consignacion' ? (
                              <span style={{ fontSize: 11, color: '#D1D5DB' }}>Sin foto</span>
                            ) : '—'}
                          </td>
                          <td style={td}>
                            {registrado ? (
                              <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: '#D1FAE5', color: '#065F46' }}>✅ Registrado</span>
                            ) : sinCierre ? (
                              <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: '#F3F4F6', color: '#9CA3AF' }}>Sin cierre</span>
                            ) : (
                              <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: '#FEF3C7', color: '#92400E' }}>⏳ Pendiente</span>
                            )}
                          </td>
                          <td style={td}>
                            {!registrado && fila.cierre_id && (
                              <button
                                onClick={() => setModalFila(fila)}
                                style={{ padding: '6px 14px', border: '2px solid #1a1a2e', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#1a1a2e', whiteSpace: 'nowrap' }}
                              >
                                + Registrar
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })
      )}

      {modalFila && (
        <ModalDestino
          fila={modalFila}
          onClose={() => setModalFila(null)}
          onGuardado={cargar}
        />
      )}

      {modalMultiple && (
        <ModalConsignacionMultiple
          filasPendientes={filas.filter(f => !f.sobre_id && f.cierre_id && (!filtroBodega || String(f.bodega_id) === String(filtroBodega)))}
          onClose={() => setModalMultiple(false)}
          onGuardado={cargar}
        />
      )}

      {fotoVisor && (
        <div onClick={() => setFotoVisor(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16, cursor: 'zoom-out' }}>
          <div style={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}>
            <img src={fotoVisor} alt="Consignación" style={{ maxWidth: '90vw', maxHeight: '85vh', borderRadius: 12, objectFit: 'contain', boxShadow: '0 8px 32px rgba(0,0,0,0.5)' }} />
            <button onClick={() => setFotoVisor(null)} style={{ position: 'absolute', top: -12, right: -12, background: '#EF4444', color: 'white', border: 'none', borderRadius: '50%', width: 32, height: 32, cursor: 'pointer', fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
            <a href={fotoVisor} download style={{ position: 'absolute', bottom: -40, left: '50%', transform: 'translateX(-50%)', background: 'white', color: '#1a1a2e', padding: '6px 16px', borderRadius: 20, fontSize: 12, fontWeight: 700, textDecoration: 'none' }}>
              ⬇ Descargar
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

const th = { padding: '10px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' };
const td = { padding: '11px 16px', verticalAlign: 'middle' };
